export const getCookie = (name, cookies) => {
    let documentCookies = '';
    if (!cookies && typeof window !== 'undefined') {
        documentCookies = document ? document.cookie : '';
    }
    const pairs = (cookies || documentCookies).split(';');
    const found = pairs
        .map(pair => pair.replace(/^[ ]+/, '').replace(/[ ]$/, ''))
        .map(pair => pair.split('='))
        .find(pair => pair[0] === name);
    return found ? decodeURIComponent(found[1]) : undefined;
};
export const serializeCookie = (name, value, expires, path, domain, secure) => {
    const expiresStr = expires ? `;expires=${expires}` : '';
    const pathStr = path ? `;path=${path}` : '';
    const domainStr = domain ? `;domain=${domain}` : '';
    const secureStr = secure ? `;secure=${secure}` : '';
    return `${name}=${encodeURIComponent(value)}${expiresStr}${pathStr}${domainStr}${secureStr}`;
};
export const setCookie = (name, value, expires = null, path = null, domain = null, secure = false) => {
    document.cookie = serializeCookie(name, value, expires, path, domain, secure);
};
export const removeCookie = ({ name, path = '/' }) => {
    // Set an expiry date in the past to make sure this cookie is expired/removed and not used anymore.
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=${path};`;
};
//# sourceMappingURL=cookies.js.map